import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { useMemo, Fragment } from 'react';
import { NumberCardListItem } from '@/components/modules/pages/rfp/client/List/NumberCardList/NumberCardListItem';
import { CaretRightIcon } from '@/components/ui/SvgIcon/Variable/SvgIconComponents';
export const NumberCardList = (props) => {
    const { announceCount = 0, approveCount = 0, className = '', isSkeleton = false, proposalCount = 0, viewRequestCount = 0, } = props;
    const cardList = useMemo(() => [
        {
            color: 'orange',
            key: 'annotation',
            label: '告知',
            value: announceCount,
        },
        {
            color: 'gray',
            key: 'view_request',
            label: '開示依頼',
            value: viewRequestCount,
        },
        {
            color: 'lightBlue',
            key: 'approve',
            label: '開示済み',
            value: approveCount,
        },
        {
            color: 'lightOrange',
            key: 'offer',
            label: '提案予定',
            value: proposalCount,
        },
    ], [announceCount, viewRequestCount, approveCount, proposalCount]);
    return (_jsx("div", Object.assign({ className: clsx('flex flex-nowrap items-center', 'gap-x-[2px] md:gap-x-8 lg:gap-x-[2px] xl:gap-x-8', className) }, { children: cardList.map((item, i) => (_jsxs(Fragment, { children: [_jsx(NumberCardListItem, { className: 'flex-1', color: item.color, headText: item.label, isSkeleton: isSkeleton, number: item.value }), cardList.length !== i + 1 && (_jsx(CaretRightIcon, { className: 'text-gray-300 mt-12 md:mt-0 lg:mt-12 xl:mt-0', color: 'none', size: 'md' }))] }, item.key))) })));
};
